/**
 * External Imports
 */
import { Dispatch, FC, SetStateAction, useState } from 'react';
import { useDispatch } from 'react-redux';

/**
 * Internal Imports
 */
import SearchHeader from '../../components/searchHeader';
import QuestionBankTable from '../../components/customTables/admin/questionBankTable';

import {
  openModal,
  setModalType,
  editSelectedQuestion,
  getCSVToExportSuccess
} from '../../redux/actions';

/**
 * Style Imports
 */
import { QuestionBankContainer } from './styles/AdminViews.styles';
import { CleanQuestion } from '../../config/interfaces';

interface QuestionBankProps {
  searchTerm: string;
  setSearchTerm: Dispatch<SetStateAction<string>>;
}

const QuestionBank: FC<QuestionBankProps> = ({ searchTerm, setSearchTerm }) => {
  const dispatch = useDispatch();

  const [csvData, setCsvData] = useState<CleanQuestion[]>([]);

  const handleExportCsv = () => {
    dispatch(getCSVToExportSuccess(csvData));
    // appInsights.trackEvent({
    //   name: 'Question_List_CSV_Downloaded'
    // });
  };

  const handleEditQuestionOnClick = (id: string) => {
    dispatch(editSelectedQuestion(id));
    dispatch(setModalType('Add Question'));
    dispatch(openModal());
  };

  return (
    <QuestionBankContainer>
      <SearchHeader
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        handleExportCsv={handleExportCsv}
      />
      <QuestionBankTable
        searchTerm={searchTerm}
        handleEditQuestion={handleEditQuestionOnClick}
        setCsvData={setCsvData}
      />
    </QuestionBankContainer>
  );
};

export default QuestionBank;
